var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generic-search-list-search-bar form" }, [
    _c("div", { staticClass: "generic-search-list-search-bar__input input" }, [
      _c("input", {
        staticClass: "search-input icon-search",
        class: [{ "have-value": !!_vm.inputString }],
        attrs: {
          id: "genericSearch",
          type: "text",
          "data-field-type": "SingleLineText",
        },
        on: {
          input: function ($event) {
            ;[_vm.triggerFilter($event), _vm.trackInput($event)]
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "floating search-label",
          attrs: { for: "genericSearch" },
        },
        [_vm._v("\n      " + _vm._s(_vm.searchPlaceholder) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }